import { useEffect } from 'react'
import * as PubSub from './pubSub'

export function useWebRecorderPubSubSubscribe<T>(event: PubSub.Event, callback: (val: T) => void, deps: any[] = []) {
  useEffect(() => {
    PubSub.subscribe(event, callback)
    return () => PubSub.unsubscribe(event, callback)
  }, deps)
}
